import { useEffect } from "react"

const OPEN_LAYER =
	'[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [role="menu"][data-state="open"]'

export function usePointerEventsGuard() {
	useEffect(() => {
		let frame = 0
		const release = () => {
			cancelAnimationFrame(frame)
			frame = requestAnimationFrame(() => {
				if (document.body.style.pointerEvents !== "none") return
				if (document.querySelector(OPEN_LAYER)) return
				document.body.style.pointerEvents = ""
			})
		}
		const observer = new MutationObserver(release)
		observer.observe(document.body, { attributes: true, attributeFilter: ["style"] })
		observer.observe(document.body, { childList: true })
		return () => {
			cancelAnimationFrame(frame)
			observer.disconnect()
		}
	}, [])
}
